import { getHexagonSizes } from './hexagon/get-hexagon-sizes.js';
import { getSquaredSizes } from './square/get-squared-sizes.js';
import type { HoneycombTileShape } from '../../types/honeycomb.js';
import type { ShapeSizes } from '../../types/rendering.js';

const ShapeBasedSizes = {
  circle: getSquaredSizes,
  hexagon: getHexagonSizes,
  square: getSquaredSizes,
};

export const getSizesAbstract = (
  shape: HoneycombTileShape,
  width: number,
): ShapeSizes => {
  return ShapeBasedSizes[shape](width);
};
